import axios from "axios";
import { notifyMsg } from "../components/common/notify";

axios.defaults.withCredentials = true;

const FORBIDDEN_MESSAGES = ["Forbidden", "Invalid role"];

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const message = error?.response?.data?.message;

    if (status === 401 && !message) {
      notifyMsg("인증이 필요합니다.", "error");
      return Promise.resolve();
    }
    if (status === 403 && (!message || FORBIDDEN_MESSAGES.includes(message))) {
      notifyMsg("접근 권한이 없습니다. 권한이 변경된 경우 로그아웃 후 재로그인 해주세요.", "error");
      return Promise.resolve();
    }

    return Promise.reject(error);
  }
);
